import script from "./ResumeHeaderEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeHeaderEditor.vue?vue&type=script&setup=true&lang=js"

import "./ResumeHeaderEditor.vue?vue&type=style&index=0&id=47194120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47194120"]])

export default __exports__